module.exports = __webpack_public_path__ + "static/media/vencimientostickets-07-rojo.44d5f128.svg";